export { default } from './ReferAFriendPage';
